import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Inject, inject, Injector, Input, OnDestroy, OnInit, Output, signal, ViewChild } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { PaylasIcerikEditorComponent } from './paylas-icerik-editor/paylas-icerik-editor.component';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';
import { IKart, IKartTuru, TurGizlilik, TurGizlilikBilgi } from '@/src/service/fikoyt-ui/interfaces/IKart.interface';
import { ServisUyarProjeler } from '@/src/app/uygulamalar/uyar-dokum/projeler/projeler.service';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzWaveModule } from 'ng-zorro-antd/core/wave';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzInputModule } from 'ng-zorro-antd/input';
import { DialogGizlilikSeciciComponent } from '../../dialog-gizlilik-secici/dialog-gizlilik-secici.component';
import { DialogEtiketlerComponent } from '../../dialog-etiketler/dialog-etiketler.component';
import { DialogKisiSeciciComponent } from '../../dialog-kisi-secici/dialog-kisi-secici.component';
import { FikoYTBayrakEditor } from '../../bayrak-editor/.component';
import { IUyarKartComponent } from './paylas-icerik-editor/IUyarDokum/uyar-kutusu.component';
import { IParametre, IParametreTumu, parametreAyikla, tumHatalariniAl } from '@/src/service/fikoyt-ui/interfaces/IParametre/IParametre';
import { ParametreSetiSeciciComponent } from './parametre-seti-secici/parametre-seti-secici.component';
import { IParametreSetiGrubu, IParametreSeti } from '@/src/service/fikoyt-ui/interfaces/IParametreSeti.interface';
import { NzDividerComponent } from "ng-zorro-antd/divider";
import { ParametrelerComponent } from '../../../parametreler/parametreler.component';
import { FikoYTIstekKok } from '@/src/service/modules/fikoyt-istek-kok/fikoyt.istek.makinesi.service';
import { PaylasKartMenuComponent } from './paylas-kart-menu/.component';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { DialogSablonSeciciComponent } from '../../dialog-sablon-secici/dialog-sablon-secici.component';
import { CanliGuncellemeService } from '../../../dinamik-bilesen/canli-guncelleme.service';
import { KartBildirimService } from '../../../dinamik-bilesen/kart-bildirim.service';
import { AltKartOzetService } from '../../../dinamik-bilesen/alt-kart-ozet.service';


declare var $: any;

@Component({
  selector: 'paylas-ikart-kutusu',
  templateUrl: './ikart-kutusu.component.html',
  styleUrls: ['./ikart-kutusu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    FormsModule,
    PaylasIcerikEditorComponent,
    NzPopconfirmModule,
    NzWaveModule,
    NzButtonModule,
    NzInputModule,
    NzDividerComponent,
    ParametrelerComponent,
    NzSpinModule,
  ]
})
export class IKartComponent extends FikoYTKokBilesenComponent implements OnInit, OnDestroy {
  @ViewChild('PaylasUyarKutusu', { static: false }) paylasUyarKutusu: IUyarKartComponent;

  private _kart: IKart | undefined;
  @Input() set kart(v: IKart | undefined) {
    this._kart = v;
    if (v && this.parametreSetiZorunlu && this.parametreSetleri?.length > 0) {
      for (const icerik of (v.veri?.icerikler ?? [])) {
        if (!icerik.ek || icerik.ek.turu !== 'UYGULAMAICERIK') {
          icerik.ek = { turu: 'UYGULAMAICERIK', _id: '', parametreler: [] };
        }
      }
    }
  }
  get kart() { return this._kart; }
  /** Düzenleme modu: mevcut bir kartı güncellemek için */
  @Input() duzenlemeModunda: boolean = false;
  /** Hibrit parametre seti grupları (kod tarafı) */
  @Input() parametreSetleri: IParametreSetiGrubu[] = [];
  /** Parametre seti seçimi zorunlu mu (true ise otomatik UYGULAMAICERIK eki atanır) */
  @Input() parametreSetiZorunlu: boolean = false;

  /** Her sayfanın seçili set id'si: sayfaIndex → setId */
  readonly sayfaSetMap = signal<Map<number, string>>(new Map());

  /** Her sayfanın seçili parametreleri: sayfaIndex → IParametre[] */
  readonly sayfaParametreMap = signal<Map<number, IParametre[]>>(new Map());

  readonly dinamikParametreler = signal<any>({});

  /** Parametre seti seçici paneli açık mı */
  parametreSetiPaneliAcik = false;

  /** Aktif sayfanın set kuralları */
  get aktifSayfaKurallari(): IParametreSeti['sayfaKurallari'] | null {
    const setId = this.sayfaSetMap().get(this.aktifIcerikNo);
    if (!setId) return null;
    for (const grup of this.parametreSetleri) {
      if (grup.id === setId) return null;
      for (const alt of (grup.altGruplar ?? [])) {
        if (alt.id === setId) return alt.sayfaKurallari ?? null;
      }
    }
    return null;
  }

  /** Aktif sayfanın seçili set id'si */
  get aktifSayfaSetId(): string | null {
    return this.sayfaSetMap().get(this.aktifIcerikNo) ?? null;
  }

  /** Taslak sistemini devre dışı bırak */
  @Input() taslakDevreDisi = false;
  /** */
  @Output() paylasimYapildi: EventEmitter<any> = new EventEmitter<any>();
  /** Düzenleme iptal edildiğinde */
  @Output() duzenlemeIptalEdildi: EventEmitter<void> = new EventEmitter<void>();
  /** */
  private _parametreleriGoster = false;
  get parametreleriGoster() { return this._parametreleriGoster; }
  set parametreleriGoster(v: boolean) {
    if (v === this._parametreleriGoster) return;
    this._parametreleriGoster = v;
    if (v) history.pushState({ paylasim: 'parametreler' }, '');
  }
  tasarimModu = false;
  /** */
  simgeButonGizlilik: string = "fa fa-globe-europe";
  /** */
  hatalar: any[] = [];
  uyarilar: any[] = [];

  ilerleme = 0;
  paylasimBasarili = false;

  paylasimSpinUyariMetni: string = "Paylaşım Yapılıyor...";

  /** 🐛 FIX: nz-spin görünürlüğü eskiden `ekleIstek.mesgul`e bağlıydı — ama bu flag
   *  çok-içerikli paylaşımlarda HER alt istek (her içerik parçası) tamamlandığında
   *  kısa süreliğine false'a düşüp bir sonraki içerik isteği başlarken tekrar true
   *  oluyordu (bkz. FikoYTIstekKok.execute()). Bu geçiş Angular'ın OnPush değişiklik
   *  algılamasına bildirilmediği için progress metni ("İçerik X/Y") güncellenen an
   *  ile spinner'ın görünür olduğu an çakışmıyordu — sonuç: ilerleme metni "takılı"
   *  görünüyordu. Artık spinner'ın görünürlüğü TÜM çoklu-istek süresince sabit kalan
   *  bu bağımsız flag'e bağlı; metin güncellemesi + detectChanges() her zaman
   *  görünür bir spinner üzerinde gerçekleşiyor. */
  paylasimIsleniyor = false;

  /** Taslak kayıt */
  private taslakZamanlayici: any = null;
  taslakMevcut: boolean = false;

  get gizlilikSimge(): string | undefined {
    return TurGizlilikBilgi[this.kart.gizlilik].simge;
  };

  get gizlilikSimgeSinif(): string | undefined {
    return TurGizlilikBilgi[this.kart.gizlilik].simgeSinif;
  };
  /** */
  mesgul: boolean = false;

  /** Sayfa geçiş animasyonu */
  sayfaAnimSinifi: string = '';
  private _sayfaAnimZamanlayici: any = null;

  /**  */
  public get aktifIcerikNo(): number {
    return this.servisUyarProjeler.aktifIcerikNo;
  }
  public set aktifIcerikNo(v: number) {
    const onceki = this.servisUyarProjeler.aktifIcerikNo;
    if (v < 0) {
      v = 0
    }
    if (v >= this.kart.veri.icerikler.length) {
      v = this.kart.veri.icerikler.length - 1;
    }
    if (v === onceki) return;
    // Sayfa geçiş yönüne göre animasyon
    this.sayfaAnimSinifi = v > onceki ? 'sayfa-cikis-sol' : 'sayfa-cikis-sag';
    this.CD.detectChanges();
    clearTimeout(this._sayfaAnimZamanlayici);
    this._sayfaAnimZamanlayici = setTimeout(() => {
      this.servisUyarProjeler.aktifIcerikNo = v;
      this.dinamikParametreleriGuncelle();
      this.sayfaAnimSinifi = v > onceki ? 'sayfa-giris-sag' : 'sayfa-giris-sol';
      this.CD.detectChanges();
      setTimeout(() => {
        this.sayfaAnimSinifi = '';
        this.CD.detectChanges();
      }, 300);
    }, 180);
  }

  /** */
  ekleIstek: FikoYTIstekKok;
  private canliGuncelleme = inject(CanliGuncellemeService);
  private kartBildirim = inject(KartBildirimService);
  private altKartOzet = inject(AltKartOzetService);

  constructor(public servisUyarProjeler: ServisUyarProjeler) {
    super();
    // Not: FikoYTKokBilesenComponent zaten FikoYT.degisti'ye subscribe oluyor ve subsList'e ekliyor.
    // Burada ek bir subscribe yaparak cift CD tetikleme ve memory leak onleniyor.
    // Kok bilesen'deki subscribe yeterli.

    this.ekleIstek = new FikoYTIstekKok({
      metod: 'POST',
      komut: `FikoYT.sistem.DB.hareketler.ekle`,
      onEkOlsun: true,
      // parametreler: { id: 123 },
      depoModu: false,
      oncelik: 0,
      gecikmeliCevap: true,
      gecikmeliCevapSuresi: 500,

    }).onHata(({ self, hatalar }) => {
      this.nzNotification.error("Hatalar Var", hatalar.map(hata => hata.mesaj).join("\n"), { nzPlacement: 'bottomRight' });
    })
      .onBaslatildi(({ self }) => {
        this.ilerleme = 0;
        this.CD.detectChanges();
      })
      .onIstekIlerleme(({ self, ilerleme }) => {
        this.ilerleme = ilerleme.yuzde;
        this.CD.detectChanges();
      })
      .onTamamlandi(({ self }) => {
        this.CD.detectChanges();
      });
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(e: PopStateEvent) {
    if (this._parametreleriGoster) {
      this._parametreleriGoster = false;
      this.CD.detectChanges();
      return;
    }
    if (this.parametreSetiPaneliAcik) {
      this.parametreSetiPaneliAcik = false;
      this.CD.detectChanges();
      return;
    }
  }

  private dinamikParametreleriGuncelle() {
    const aktifIcerik = this.kart?.veri?.icerikler?.[this.aktifIcerikNo];
    if (aktifIcerik?.ek?.bilesen) {
      this.dinamikParametreler.set({ kart: this.kart, icerik: aktifIcerik, ek: aktifIcerik.ek });
    }
  }

  ngOnInit(): void {
    if (this.duzenlemeModunda) {
      this.paylasimSpinUyariMetni = "Güncelleniyor...";
    } else if (!this.taslakDevreDisi) {
      this.taslakKontrolEt();
    }
    // Parametre setleri varsa paneli default açık başlat
    if (this.parametreSetleri?.length > 0) {
      this.parametreSetiPaneliAcik = true;
    }
    // Parametre seti zorunlu ise her içeriğe otomatik UYGULAMAICERIK eki ata
    if (this.parametreSetiZorunlu && this.parametreSetleri?.length > 0) {
      for (const icerik of (this.kart?.veri?.icerikler ?? [])) {
        if (!icerik.ek || icerik.ek.turu !== 'UYGULAMAICERIK') {
          icerik.ek = { turu: 'UYGULAMAICERIK', _id: '', parametreler: [] };
        }
      }
    }
    this.dinamikParametreleriGuncelle();
  }

  // --- Taslak Sistemi ---

  private get taslakAnahtar(): string {
    const kullaniciId = this.FikoYT?.kimlik?.aktifKullaniciJson()?._id ?? 'anonim';
    const kartTuru = this.kart?.turu ?? IKartTuru.KART;
    return `fikoyt_taslak_${kullaniciId}_${kartTuru}`;
  }

  taslakKontrolEt() {
    // Taslak uyarısı devre dışı
  }

  taslakYukle() {
    try {
      const kayitli = localStorage.getItem(this.taslakAnahtar);
      if (kayitli) {
        const taslak = JSON.parse(kayitli);
        if (taslak && this.kart) {
          this.kart.veri = taslak.veri ?? this.kart.veri;
          this.kart.gizlilik = taslak.gizlilik ?? this.kart.gizlilik;
          this.kart.etiketler = taslak.etiketler ?? this.kart.etiketler;
          this.kart.kisiler = taslak.kisiler ?? this.kart.kisiler;
          this.kart.parametreler = taslak.parametreler ?? this.kart.parametreler;
          if (taslak._sayfaSetMap) {
            this.sayfaSetMap.set(new Map(Object.entries(taslak._sayfaSetMap).map(([k, v]) => [Number(k), v as string])));
          }
          if (taslak._sayfaParametreMap) {
            this.sayfaParametreMap.set(new Map(
              Object.entries(taslak._sayfaParametreMap).map(([k, v]) => [Number(k), v as IParametre[]])
            ));
          }
          this.taslakMevcut = false;
          this.CD.detectChanges();
        }
      }
    } catch (e) { }
  }

  taslakReddet() {
    this.taslakTemizle();
    this.taslakMevcut = false;
    this.CD.detectChanges();
  }

  taslakKaydet() {
    if (this.taslakDevreDisi) return;
    if (this.taslakZamanlayici) {
      clearTimeout(this.taslakZamanlayici);
    }
    this.taslakZamanlayici = setTimeout(() => {
      try {
        if (!this.kart) return;
        const taslakVeri = {
          veri: this.kart.veri,
          gizlilik: this.kart.gizlilik,
          etiketler: this.kart.etiketler,
          kisiler: this.kart.kisiler,
          parametreler: this.kart.parametreler,
          tarih: new Date().toISOString(),
          _sayfaSetMap: Object.fromEntries(this.sayfaSetMap()),
          _sayfaParametreMap: Object.fromEntries(
            Array.from(this.sayfaParametreMap().entries()).map(([k, v]) => [k, JSON.parse(JSON.stringify(v))])
          ),
        };
        localStorage.setItem(this.taslakAnahtar, JSON.stringify(taslakVeri));
      } catch (e) { }
    }, 3000);
  }

  taslakTemizle() {
    try {
      localStorage.removeItem(this.taslakAnahtar);
      if (this.taslakZamanlayici) {
        clearTimeout(this.taslakZamanlayici);
        this.taslakZamanlayici = null;
      }
    } catch (e) { }
  }

  tiklandiSablondanOlustur() {
    let test = this.nzModalServis.create({
      nzContent: DialogSablonSeciciComponent,
      nzDraggable: true,
      nzFooter: null,
      nzClosable: false,
      nzMaskClosable: true,
      nzBodyStyle: { padding: '10px' },
      nzStyle: { padding: '0', 'max-width': '420px' },
    }).afterClose.subscribe((sablon) => {
      if (sablon?.parametreler) {
        // Şablon parametrelerini kopyala (değerler boş)
        const parametreler = sablon.parametreler.map((p: any) => ({
          ...JSON.parse(JSON.stringify(p)),
          degeri: null
        }));

        if (!this.kart.parametreler) this.kart.parametreler = [];
        this.kart.parametreler.push(...parametreler);
        this.kart.sablonId = sablon._id;
        this.parametreleriGoster = true;
        this.taslakKaydet();
        this.nzNotification.success('Şablon Yüklendi', `${sablon.veri?.sablonAdi || 'Şablon'} - ${parametreler.length} parametre eklendi`);
      }
      test.unsubscribe();
      this.CD.detectChanges();
    });
  }

  gizlilikDegisti($event: string) {
    this.taslakKaydet();
    this.CD.detectChanges();
  }


  tiklandiIcerikSil($event: any) {

    this.kart.veri.icerikler.splice(this.aktifIcerikNo, 1);
    if (this.aktifIcerikNo == 0) {
      this.aktifIcerikNo = 0;
    } else {
      this.aktifIcerikNo = this.aktifIcerikNo - 1;
    }
    this.taslakKaydet();
    this.CD.detectChanges();

  }

  tiklandiTumIcerikleriSil($event: any) {


    this.servisUyarProjeler.sifirla();
    // _this.FikoYT.paylas.kart.veri.icerikler = [];
    // // _this.FikoYT.paylas.icerikEkle();
    // if (_this.aktifIcerikNo == 0) {
    this.aktifIcerikNo = 0;

    this.taslakKaydet();
    this.CD.detectChanges();

  }

  tiklandiDialogGizlilik() {
    let test = this.nzModalServis.create({
      nzContent: DialogGizlilikSeciciComponent,
      nzDraggable: false,
      nzData: { gizlilik: this.kart.gizlilik, liste: this.kart.gizlilikListe },
      // nzTitle: '', // Boş string, null değil
      nzFooter: null, // Footer'ı kaldır
      nzClosable: false, // Sağ üst çarpı butonu görünmesin
      nzMaskClosable: false, // Maskeye tıklayınca kapanabilsin
      nzBodyStyle: { padding: '10px', }, // İç padding'i kaldır
      nzStyle: { padding: '0', 'max-width': '360px' }, // Dış padding'i de kaldır
      nzMaskStyle: { 'background-color': 'rgba(0, 0, 0, 0.3)' }
    }).afterClose.subscribe((data) => {
      if (data) {
        this.kart.gizlilik = data?.gizlilik;
        this.kart.gizlilikListe = data?.liste ?? [];
        this.gizlilikDegisti(data?.gizlilik);
      }
      test.unsubscribe();
      this.CD.detectChanges();
    });
  }

  tiklandiDialogKisiSecici() {
    let test = this.nzModalServis.create({
      nzContent: DialogKisiSeciciComponent,
      nzDraggable: true,
      nzData: { kisiler: this.kart.kisiler ?? [] },
      // nzTitle: '', // Boş string, null değil
      nzFooter: null, // Footer'ı kaldır
      nzClosable: false, // Sağ üst çarpı butonu görünmesin
      nzMaskClosable: false, // Maskeye tıklayınca kapanabilsin
      nzBodyStyle: { padding: '10px', }, // İç padding'i kaldır
      nzStyle: { padding: '0', 'max-width': '360px' }, // Dış padding'i de kaldır

    }).afterClose.subscribe((data) => {
      if (data) {
        this.kart.kisiler = data?.kisiler ?? this.kart.kisiler;
      }
      test.unsubscribe();
      this.taslakKaydet();
      this.CD.detectChanges();
    });
  }

  tiklandiDialogEtiketler() {
    let test = this.nzModalServis.create({
      nzContent: DialogEtiketlerComponent,
      nzDraggable: true,
      nzData: { etiketler: this.kart.etiketler ?? [] },
      // nzTitle: '', // Boş string, null değil
      nzFooter: null, // Footer'ı kaldır
      nzClosable: false, // Sağ üst çarpı butonu görünmesin
      nzMaskClosable: false, // Maskeye tıklayınca kapanabilsin
      nzBodyStyle: { padding: '10px', }, // İç padding'i kaldır
      nzStyle: { padding: '0', 'max-width': '360px' }, // Dış padding'i de kaldır
    }).afterClose.subscribe((data) => {
      if (data) {
        this.kart.etiketler = data
      }
      test.unsubscribe();
      this.taslakKaydet();
      this.CD.detectChanges();
    });
  }

  async tiklandiKonumSec() {
    const { HaritaYerSeciciComponent } = await import('@/src/app/uygulamalar/soyagaci/harita-yer-secici/harita-yer-secici.component');
    const sub = this.nzModalServis.create({
      nzTitle: 'Konum Seç',
      nzContent: HaritaYerSeciciComponent,
      nzWidth: 520,
      nzFooter: null,
      nzData: {
        mevcutYer: this.kart?.konum?.yerIsmi || '',
        mevcutKoordinat: this.kart?.konum?.koordinat || null,
      },
    }).afterClose.subscribe((sonuc: any) => {
      if (sonuc?.yerIsmi) {
        if (!this.kart.konum) this.kart.konum = {} as any;
        this.kart.konum.yerIsmi = sonuc.yerIsmi;
        this.kart.konum.koordinat = sonuc.koordinat;
      }
      sub.unsubscribe();
      this.taslakKaydet();
      this.CD.detectChanges();
    });
  }

  tiklandiBayrak() {
    let test = this.nzModalServis.create({
      nzContent: FikoYTBayrakEditor,
      nzDraggable: true,
      nzData: { bayrak: this.kart?.veri.solSimge },
      // nzTitle: '', // Boş string, null değil
      nzFooter: null, // Footer'ı kaldır
      nzClosable: false, // Sağ üst çarpı butonu görünmesin
      nzMaskClosable: false, // Maskeye tıklayınca kapanabilsin
      nzBodyStyle: { padding: '10px', }, // İç padding'i kaldır
      nzStyle: { padding: '0', 'max-width': '360px' }, // Dış padding'i de kaldır
    }).afterClose.subscribe((data) => {
      if (data?.bayrak) {
        this.kart.veri.solSimge = data?.bayrak;
      }
      this.CD.detectChanges();
      this.FikoYT.degisti.emit();
      this.taslakKaydet();
      test.unsubscribe();
    });
  }
  tiklandiMenu() {
    let test = this.nzModalServis.create({
      nzContent: PaylasKartMenuComponent,
      nzDraggable: true,
      nzFooter: null,
      nzClosable: false,
      nzMaskClosable: true,
      nzBodyStyle: { padding: '10px' },
      nzStyle: { padding: '0', 'max-width': '360px' },
    }).afterClose.subscribe((data) => {
      if (data?.aksiyon) {
        switch (data.aksiyon) {
          case 'kopyala':
            this.kartKopyala();
            break;
          case 'bayrak':
            this.tiklandiBayrak();
            break;
          case 'sifirla':
            this.sifirla();
            this.nzNotification.info('Sıfırlandı', 'Kart sıfırlandı', { nzPlacement: 'bottomRight' });
            break;
          case 'taslakKaydet':
            this.taslakKaydet();
            this.nzNotification.success('Kaydedildi', 'Taslak kaydedildi', { nzPlacement: 'bottomRight' });
            break;
        }
      }
      this.CD.detectChanges();
      this.FikoYT.degisti.emit();
      test.unsubscribe();
    });
  }

  onSetSecildi(olay: { setId: string; parametreler: IParametre[]; sayfaKurallari?: any; bilesen?: string; bilesenGorunum?: string }) {
    const icerik = this.kart?.veri?.icerikler?.[this.aktifIcerikNo];
    if (olay.bilesen && icerik) {
      if (!icerik.ek) icerik.ek = {};
      icerik.ek.bilesen = olay.bilesen;
      icerik.ek._secilenSetId = olay.setId;
      if (olay.bilesenGorunum) icerik.ek.bilesenGorunum = olay.bilesenGorunum;
      this.dinamikParametreleriGuncelle();
      this.parametreSetiPaneliAcik = false;
      this.taslakKaydet();
      this.CD.detectChanges();
      return;
    }
    this.sayfaSetMap.update(m => {
      const yeni = new Map(m);
      yeni.set(this.aktifIcerikNo, olay.setId);
      return yeni;
    });
    const setSablonu = this.setSablonBul(olay.setId);
    if (icerik?.ek && setSablonu) {
      icerik.ek.sablon = JSON.parse(JSON.stringify(setSablonu));
    }
    this.parametreSetiPaneliAcik = false;
    this.taslakKaydet();
    this.CD.detectChanges();
  }

  private setSablonBul(setId: string): any {
    for (const grup of (this.parametreSetleri ?? [])) {
      if (grup.id === setId && grup.sablon) return grup.sablon;
      for (const alt of (grup.altGruplar ?? [])) {
        if (alt.id === setId && alt.sablon) return alt.sablon;
        for (const altKart of (alt.altKartSablonlari ?? [])) {
          if (altKart.id === setId && (altKart as any).sablon) return (altKart as any).sablon;
        }
      }
    }
    return null;
  }

  onSetKaldirildi() {
    this.sayfaSetMap.update(m => {
      const yeni = new Map(m);
      yeni.delete(this.aktifIcerikNo);
      return yeni;
    });
    // Set kaldırıldı → paneli tekrar aç (mecburi seçim)
    if (this.parametreSetleri?.length > 0) {
      this.parametreSetiPaneliAcik = true;
    }
    this.taslakKaydet();
    this.CD.detectChanges();
  }

  onSetParametrelerDegisti(parametreler: IParametre[]) {
    // Parametreler icerik eki içinde, sadece taslak kaydet
    this.taslakKaydet();
  }


  icerikEkle(ek: any = null) {
    // Sayfa kuralları kontrolü
    const kurallar = this.aktifSayfaKurallari;
    if (kurallar?.yeniSayfaEngelle) return;
    if (kurallar?.maxSayfa && (this.kart?.veri?.icerikler?.length ?? 0) >= kurallar.maxSayfa) return;

    // Parametre seti zorunlu ise otomatik UYGULAMAICERIK eki ata
    if (!ek && this.parametreSetiZorunlu && this.parametreSetleri?.length > 0) {
      ek = { turu: 'UYGULAMAICERIK', _id: '', parametreler: [] };
    }
    this.kart?.veri?.icerikler?.push({ _id: this.FikoYT.fikoIdUret(), aciklama: '', html: '', ek: ek, sifre: null }) ?? 1 - 1;
    this.taslakKaydet();
  }

  sifirla() {
    this.kart = {
      _id: this.FikoYT.fikoIdUret(),
      vt: "FikoYT.sistem.hareketler",
      turu: IKartTuru.KART,
      gizlilik: "Herkese Açık",
      kisiler: [],
      veri: {
        solSimge: {
          aciklama: undefined,
          baslik: "FikoYT",
          renkArka: undefined,
          renkYazi: undefined,
        },
        kurdela: {
          aciklama: undefined,
          baslik: "FikoYT",
          renkArka: undefined,
          renkYazi: undefined,
        },
        icerikler: []
      }
    }
    this.sayfaSetMap.set(new Map());
    this.sayfaParametreMap.set(new Map());
    this.tasarimModu = false;
    this.aktifIcerikNo = 0;
    this.hatalar = [];
    this.uyarilar = [];
    this.icerikEkle();
  }

  aktifEtSonSayfa() {
    this.aktifIcerikNo = (this.kart?.veri?.icerikler?.length ?? 1) - 1;
  }

  override ngOnDestroy(): void {
    if (this.taslakZamanlayici) {
      clearTimeout(this.taslakZamanlayici);
    }
    super.ngOnDestroy();
  }

  /**
   * Kart verisinin derin kopyasını oluşturur.
   * structuredClone File/Blob ve SafeValue nesnelerini klonlayamaz,
   * bu yüzden dosya referanslarını ayırıp JSON kopyalama yapıyoruz.
   */
  private kartDerinKopya(kaynak: any): { kopyaKart: any, dosyaHaritasi: Map<string, { dosya: File | Blob, objectUrl: any }> } {
    const dosyaHaritasi = new Map<string, { dosya: File | Blob, objectUrl: any }>();

    // Dosya referanslarını topla ve geçici olarak kaldır
    const icerikler = kaynak?.veri?.icerikler ?? [];
    const geciciDosyalar: any[] = [];

    for (let i = 0; i < icerikler.length; i++) {
      const ek = icerikler[i]?.ek;
      if (ek) {
        geciciDosyalar[i] = {
          dosya: ek.dosya,
          dosyaObjectUrl: ek.dosyaObjectUrl,
          resim: ek.resim,
          resimObjectUrl: ek.resimObjectUrl,
        };
        // Dosya referanslarını geçici olarak null yap (JSON.stringify için)
        if (ek.dosya instanceof File || ek.dosya instanceof Blob) {
          dosyaHaritasi.set(ek._id, { dosya: ek.dosya, objectUrl: ek.dosyaObjectUrl });
          ek.dosya = null;
          ek.dosyaObjectUrl = null;
        } else if (ek.dosya) {
          // Önceki bir JSON.stringify turundan kalan Blob artığı: Blob JSON'da {} olur.
          // Gerçek File/Blob değilse (ör. {} sızıntısı) sunucuya {} olarak gitmesin —
          // yoksa mevcut dosya referansını üzerine yazıp 3D/model bağlantısını bozar.
          ek.dosya = null;
        }
        if (ek.resim instanceof File || ek.resim instanceof Blob) {
          dosyaHaritasi.set(ek._id + '_resim', { dosya: ek.resim, objectUrl: ek.resimObjectUrl });
          ek.resim = null;
          ek.resimObjectUrl = null;
        } else if (ek.resim) {
          // Aynı sızıntı: STP ekran görüntüsü (ek.resim) için de geçerli.
          ek.resim = null;
        }
      }
    }

    // JSON kopyala (güvenli - SafeValue/File yok)
    const kopyaKart = JSON.parse(JSON.stringify(kaynak));

    // Orijinal kartın dosya referanslarını geri yükle — SADECE gerçek File/Blob ise.
    // Leaked {} (önceki bir JSON turundan kalan Blob artığı) geri yüklenmez, kalıcı olarak
    // null'a çevrilir; aksi halde bu obje canlı kartta kalıp bir sonraki kayıtta tekrar sızar.
    for (let i = 0; i < icerikler.length; i++) {
      const ek = icerikler[i]?.ek;
      if (ek && geciciDosyalar[i]) {
        const gd = geciciDosyalar[i];
        ek.dosya = (gd.dosya instanceof File || gd.dosya instanceof Blob) ? gd.dosya : null;
        ek.dosyaObjectUrl = ek.dosya ? gd.dosyaObjectUrl : gd.dosyaObjectUrl;
        ek.resim = (gd.resim instanceof File || gd.resim instanceof Blob) ? gd.resim : null;
        ek.resimObjectUrl = ek.resim ? gd.resimObjectUrl : gd.resimObjectUrl;
      }
    }

    return { kopyaKart, dosyaHaritasi };
  }

  /** 📢 premium özellik lisansı (köprü yoksa AÇIK). */
  lisans(alt: string): boolean { try { return (window as any).__fikoLisans?.('📢', alt) ?? true; } catch { return true; } }

  /** Kartı kopyala / çoğalt - spread ile File/Blob/SafeValue referanslarını korur */
  kartKopyala() {
    if (!this.kart) return;
    if (!this.lisans('kart_klon')) { this.nzMessage?.warning('Kart klonlama özelliği lisansınızda yok.'); return; }

    // Spread ile sığ kopya: File, Blob, SafeValue referansları korunur
    const yeniIcerikler = (this.kart.veri?.icerikler ?? []).map(icerik => {
      const yeniIcerik: any = {
        ...icerik,
        _id: this.FikoYT.fikoIdUret(),
      };

      if (icerik.ek) {
        yeniIcerik.ek = {
          ...icerik.ek,  // dosya, dosyaObjectUrl, resim, resimObjectUrl referansları korunur
          _id: this.FikoYT.fikoIdUret(),
        };
        // Parametreleri derin kopyala (serileştirilebilir veri)
        if (icerik.ek.parametreler) {
          try {
            yeniIcerik.ek.parametreler = JSON.parse(JSON.stringify(icerik.ek.parametreler));
          } catch { }
        }
      }

      return yeniIcerik;
    });

    this.kart._id = this.FikoYT.fikoIdUret();
    this.kart.veri = {
      ...this.kart.veri,
      solSimge: this.kart.veri.solSimge ? { ...this.kart.veri.solSimge } : undefined,
      kurdela: this.kart.veri.kurdela ? { ...this.kart.veri.kurdela } : undefined,
      icerikler: yeniIcerikler,
    };
    this.kart.etiketler = [...(this.kart.etiketler ?? [])];
    this.kart.kisiler = [...(this.kart.kisiler ?? [])];

    this.aktifIcerikNo = 0;
    this.taslakKaydet();
    this.nzNotification.success('Kopyalandı', 'Kart başarıyla kopyalandı', { nzPlacement: 'bottomRight' });
    this.CD.detectChanges();
  }

  async paylasTiklandi() {
    this.kart._id ??= this.FikoYT.fikoIdUret();

    const sonuc = { hatalar: [] as any[], uyarilar: [] as any[] };

    for (let i = 0; i < this.kart.veri?.icerikler?.length; i++) {
      const icerik = this.kart.veri.icerikler[i];
      const etiket = i == 0 ? "ilk" : i + 1 + " nolu";
      const ekParametreler = icerik?.ek?.parametreler ?? [];

      if (icerik.ek?.turu == "UYARDOKUM") {
        // UYARDOKUM: parametreleri kontrol et
        if (ekParametreler.length < 1) {
          sonuc.hatalar.push({ mesaj: `${etiket} içerikte işlenecek veri bulunamadı.` });
        } else {
          let parametreHatalar = await tumHatalariniAl(ekParametreler);
          for (let j = 0; j < parametreHatalar.hatalar.length; j++) {
            sonuc.hatalar.push({ mesaj: `${etiket} içerikte ${parametreHatalar.hatalar[j].hatalar.map(hata => hata.mesaj).join("\n")}` });
          }
          for (let k = 0; k < parametreHatalar.uyarilar.length; k++) {
            sonuc.uyarilar.push({ mesaj: `${etiket} içerikte ${parametreHatalar.uyarilar[k].uyarilar.map(uyari => uyari.mesaj).join("\n")}` });
          }
        }
      } else if (ekParametreler.length > 0) {
        // Parametreli içerik: parametrelerin validasyonunu çalıştır
        let parametreHatalar = await tumHatalariniAl(ekParametreler);
        for (let j = 0; j < parametreHatalar.hatalar.length; j++) {
          sonuc.hatalar.push({ mesaj: `${etiket} içerikte ${parametreHatalar.hatalar[j].hatalar.map(hata => hata.mesaj).join("\n")}` });
        }
        for (let k = 0; k < parametreHatalar.uyarilar.length; k++) {
          sonuc.uyarilar.push({ mesaj: `${etiket} içerikte ${parametreHatalar.uyarilar[k].uyarilar.map(uyari => uyari.mesaj).join("\n")}` });
        }
      } else {
        // Parametresiz normal içerik: html veya ek olmalı
        const ekGecerli = icerik.ek?.dosya != null || icerik.ek?.rid != null || icerik.ek?.bilesen != null || (this.duzenlemeModunda && icerik.ek?._id);
        if (icerik.html == "" && !ekGecerli) {
          sonuc.hatalar.push({ mesaj: `${etiket} içerikte geçersiz yada boş sayfalar var.` });
        }
      }
    }

    this.hatalar = sonuc.hatalar;
    this.uyarilar = sonuc.uyarilar;

    this.FikoYT.degisti.emit();
    this.CD.detectChanges();
    if (sonuc.hatalar.length > 0) {
      return;
    }

    // Çoklu-istek süresi boyunca sabit kalacak spinner flag'i — bkz. paylasimIsleniyor tanımı
    this.paylasimIsleniyor = true;
    this.CD.detectChanges();

    // Derin kopya: File/Blob ve SafeValue nesnelerini koruyarak kopyala
    const { kopyaKart: kart, dosyaHaritasi } = this.kartDerinKopya(this.kart);

    if (this.duzenlemeModunda) {
      kart.duzenlenmeTarihi = new Date();
    } else {
      kart.sahip = this.FikoYT.kimlik.aktifKullaniciJson()._id;
      kart.tarih = new Date();
    }

    // İçerikleri ayrı kopyala (JSON kopyası zaten yapıldı)
    const icerikler = JSON.parse(JSON.stringify(kart.veri.icerikler));

    let forFormData = { json: undefined, dosyalar: [] };

    for (let i = 0; i < kart.veri.icerikler.length; i++) {
      kart.veri.icerikler[i] = kart.veri.icerikler[i]._id;
      icerikler[i]._uid = kart._id;

      forFormData.dosyalar = [...forFormData.dosyalar, ...(parametreAyikla(icerikler?.[i]?.ek?.parametreler ?? []).dosyalar)];

      // Sablon resim dosyaları (File nesneleri JSON.stringify'da kaybolur)
      const sablonDosyalar = this.kart?.veri?.icerikler?.[i]?.ek?._sablonDosyalar;
      if (sablonDosyalar?.length) {
        for (const sd of sablonDosyalar) {
          forFormData.dosyalar = [...forFormData.dosyalar, {
            _id: 'sablon_' + sd.elementId,
            dosya: sd.dosya,
            objectUrl: sd.objectUrl,
          }];
          // Sablon elementindeki objectUrl'yi sunucu referansına çevir
          const sablon = icerikler[i]?.ek?.sablonOverride || icerikler[i]?.ek?.sablon;
          if (sablon?.elementler) {
            const el = sablon.elementler.find((e: any) => e.id === sd.elementId);
            if (el) el.resimUrl = 'sablon_' + sd.elementId;
          }
        }
        // _sablonDosyalar'ı JSON'dan temizle (File serialize edilemez)
        delete icerikler[i].ek._sablonDosyalar;
      }

      // Dosya referanslarını haritadan geri al
      const ekId = icerikler?.[i]?.ek?._id;
      if (ekId) {
        const dosyaRef = dosyaHaritasi.get(ekId);
        if (dosyaRef?.dosya) {
          forFormData.dosyalar = [...forFormData.dosyalar, {
            _id: ekId.toString(),
            dosya: dosyaRef.dosya,
            objectUrl: dosyaRef.objectUrl
          }];
        }
        const resimRef = dosyaHaritasi.get(ekId + '_resim');
        if (resimRef?.dosya) {
          forFormData.dosyalar = [...forFormData.dosyalar, {
            _id: (icerikler?.[i]?.ek?.resimid ?? ekId + '_resim').toString(),
            dosya: resimRef.dosya,
            objectUrl: resimRef.objectUrl
          }];
        }
      }
    }

    // Parametre seti seçimlerini karta ekle
    if (this.sayfaSetMap().size > 0) {
      kart.veri._parametreSetleri = Object.fromEntries(this.sayfaSetMap());
    }

    const formData = new FormData();
    formData.append("req_body", JSON.stringify(kart));

    this.ekleIstek.parametreler = formData;

    let cevap: any = await this.ekleIstek.isteSync();

    if (cevap.cevap.sonuc) {
      const icerikSayisi = icerikler.length;
      // İlerleme çubuğunu sıfırla ve görünürlüğü hemen güncelle (OnPush)
      this.ilerleme = 0;
      this.CD.detectChanges();
      for (let i = 0; i < icerikler.length; i++) {
        this.aktifIcerikNo = i;
        const formData1 = new FormData();
        formData1.append("req_body", JSON.stringify(icerikler[i]));

        for (const d of forFormData.dosyalar) {
          if (d.dosya) {
            formData1.append(d._id, d.dosya, d.dosya.name ?? 'dosya');
          }
        }

        this.ekleIstek.parametreler = formData1;

        // İlerleme çubuğunu içerik oranına göre kademeli ilerlet.
        // Yalnızca UploadProgress'a bağımlı olmak küçük/tek-kilobyte payload'larda
        // çubuğun ilerlememesine yol açıyordu; bu yüzden her içerik için taban
        // ilerlemeyi burada hesaplayıp çubuğu zorla ilerletiyoruz. Uploadprogress
        // yine gelirse onu takip etmek üzere max() kullanıyoruz.
        const ilerlemeOrani = icerikSayisi > 0 ? ((i + 1) / icerikSayisi) * 100 : 0;
        if (this.ilerleme === 0 || ilerlemeOrani > this.ilerleme) {
          this.ilerleme = Math.min(ilerlemeOrani, 100);
        }
        // ASYNC operasyondan sonra detectChanges() DOM'u güncellemez (OnPush),
        // bu yüzden bir sonraki makro görevde DOM güncellenmeli.
        this.CD.detectChanges();
        this.paylasimSpinUyariMetni = this.duzenlemeModunda
          ? `İçerik ${i + 1}/${icerikler.length} güncelleniyor`
          : `Kart ${i + 1}/${icerikler.length} paylaşılıyor`;
        cevap = await this.ekleIstek.isteSync();
      }

      // DB'ye id-liste gönderildikten sonra, canlı yayın & beslek için veri
      // yapısını hydrate edilmiş (tam IIcerik[]) hâle restore et. Aksi halde
      // kartYerineKoy / guncellemeYayin besleğe `veri.icerikler` = [id, id,...]
      // (string dizi) gönderir → icerikler bileşeni ek.obje okurken patlar,
      // STP/WRL tür tanısı (`ek.ismi.endsWith('.wrl')`) çalışmaz, resimid/3D
      // "görünmez" olur. `paylasYapildi.emit(kart)` da aynı objeyi alır.
      if (kart?.veri) kart.veri.icerikler = icerikler;
      kart.icerikler = icerikler;

      // 🚀 PERFORMANS: Bu kart bir alt kart ise (_uid'si var — durum güncelleme,
      // yorum vb.), üst kartın önbelleklenmiş özet alanlarını (_hesap.*, yorumSayisi)
      // arka planda yeniden hesaplat. Feed artık bunu canlı $lookup ile hesaplamıyor.
      // Kütük stokta sayım hareketi geldiyse, önce fark fire/giriş kaydı DB'ye yazılır.
      if ((kart as any)?._uid) {
        await this._kutukStokSayimFarkKaydet(kart, icerikler);
        this.altKartOzet.ozetGuncelle((kart as any)._uid);
      }

      if (this.duzenlemeModunda) {
        this.nzNotification.success("Başarılı", `Kart Güncellendi`, { nzPlacement: 'bottomRight' });
        if (kart?._id && this.lisans('canli_yayin')) this.canliGuncelleme.guncellemeYayin(kart._id, { ...kart, veri: { ...kart.veri, icerikler } });
        if (kart?._id) this.kartBildirim.bildirimTetikle('kart_guncellendi', kart._id, kart.sahip, kart.veri?.kurdela?.baslik);
        this.mentionBildirimGonderInternal(kart, icerikler);
        this.paylasimYapildi.emit(kart);
        this.paylasimSpinUyariMetni = `Güncelleme Tamamlandı.`;
        this.paylasimIsleniyor = false;
        this.CD.detectChanges();
      } else {
        this.nzNotification.success("Başarılı", `Kart Paylaşıldı`, { nzPlacement: 'bottomRight' });

        // Başarılı paylaşımda taslağı temizle
        this.taslakTemizle();

        // Konfeti efekti
        this.paylasimBasarili = true;
        this.CD.detectChanges();
        setTimeout(() => {
          this.paylasimBasarili = false;
          this.CD.detectChanges();
        }, 1800);

        setTimeout(() => {
          if (this.lisans('canli_yayin')) this.canliGuncelleme.yeniYayin({ ...kart, veri: { ...kart.veri, icerikler } });
          if (kart?._id) this.kartBildirim.bildirimTetikle('kart_olusturuldu', kart._id, kart.sahip, kart.veri?.kurdela?.baslik);
          this.mentionBildirimGonderInternal(kart, icerikler);
          this.paylasimYapildi.emit(kart);
          this.paylasimSpinUyariMetni = `Paylaşım Tamamlandı.`;
          this.paylasimIsleniyor = false;
          // İç durumu temizle (sayfaSetMap, hatalar vs.)
          this.sayfaSetMap.set(new Map());
          this.sayfaParametreMap.set(new Map());
          this.aktifIcerikNo = 0;
          this.hatalar = [];
          this.uyarilar = [];
          // Kart objesini sıfırla
          this.servisUyarProjeler.sifirla();
          this.CD.detectChanges();
        },)
      }
    }
    else {
      this.nzNotification.error("Hata", `Kart Paylaşılamadı`, { nzPlacement: 'bottomRight' });
      this.paylasimIsleniyor = false;
      this.CD.detectChanges();
    }
  }
/** Kütük stokta "sayım" hareketi kaydedildiğinde, birikmiş stok ile girilen sayım
   *  arasındaki farkı ayrı bir fire/giriş alt-kartı olarak DB'ye yazar. Böylece kullanıcı
   *  "sayım: 10" derse (önceki 50 idi), stok 10 kalır ve -40 yalnızca otomatik bir
   *  "kayıp" fire kaydı olarak ayrı hareket görünür.
   *  Not: Bu metod fark kaydını üst (kütük) karta yazar; sayımın kendisi düşülmez çünkü
   *  kalanStok reduce'u artık sayımı etkisiz sayar (bkz. alt-kart-ozet / prepipe). */
  private async _kutukStokSayimFarkKaydet(kart: any, icerikler: any[]) {
    let parentId: string | null = null;
    try {
      parentId = (kart as any)?._uid;
      if (!parentId) return;
      const sayimIc = (icerikler || []).find((i: any) =>
        i?.ek?._secilenSetId === 'kutuk-stok.hareket' && this._ekDeger(i?.ek, 'tip') === 'sayim'
      );
      if (!sayimIc) return;
      const sayimMiktar = +(this._ekDeger(sayimIc.ek, 'miktar') || 0) || 0;

      // Üst kartın bu sayım öncesi birikmiş stoğunu aggregate ile çek
      const istek = new FikoYTIstekKok({ metod: 'POST', komut: 'FikoYT.sistem.DB.hareketler.aggregate' });
      istek.parametreler = { aggregate: [
        { $match: { _id: parentId } },
        { $lookup: { from: 'hareketler', let: { pid: '$_id' }, pipeline: [
          { $match: { $expr: { $eq: ['$_uid', '$$pid'] }, silindi: { $ne: true } } },
          { $lookup: { from: 'hareketler', localField: 'veri.icerikler', foreignField: '_id', as: 'ic' } },
          { $unwind: { path: '$ic', preserveNullAndEmptyArrays: false } },
          { $match: { 'ic.ek._secilenSetId': 'kutuk-stok.hareket' } },
          { $sort: { _id: 1 } },
          { $project: {
            _id: '$ic._id',
            tip: '$ic.ek.tip',
            miktar: { $toDouble: { $ifNull: ['$ic.ek.miktar', 0] } },
          } },
        ], as: '_alt' } },
        { $addFields: {
          kalan: {
            $reduce: {
              input: '$_alt', initialValue: 0,
              in: { $switch: { branches: [
                { case: { $eq: ['$$this.tip', 'giris'] }, then: { $add: ['$$value', '$$this.miktar'] } },
                { case: { $in: ['$$this.tip', ['cikis', 'fire']] }, then: { $subtract: ['$$value', '$$this.miktar'] } },
                { case: { $eq: ['$$this.tip', 'sayim'] }, then: '$$value' },
              ], default: '$$value' } } },
          },
        } },
        { $project: { _alt: 0 } },
      ] };
      const cevap: any = await istek.isteSync();
      const eskiStok = +(cevap?.cevap?.sonuc?.[0]?.kalan ?? 0);
      const fark = eskiStok - sayimMiktar;
      if (fark === 0) return;

      const farkTip = fark > 0 ? 'fire' : 'giris';
      const farkMiktar = Math.abs(fark);

      const sahip = this.FikoYT.kimlik.aktifKullaniciJson()?._id;
      const kartKimlik = this.FikoYT.fikoIdUret();
      const icerikKimlik = this.FikoYT.fikoIdUret();

      const farkKart: any = {
        _id: kartKimlik, vt: 'FikoYT.sistem.hareketler', yol: 'FikoYT.sistem.hareketler.kalem',
        turu: 'KART', gizlilik: 'Herkese Açık', _uid: parentId, sahip, tarih: new Date(),
        veri: { solSimge: { baslik: farkTip === 'fire' ? '🔥' : '⬆', renkArka: farkTip === 'fire' ? '#f59e0b' : '#22c55e', renkYazi: '#fff' }, icerikler: [icerikKimlik] },
      };
      const farkIcerik: any = {
        _id: icerikKimlik, _uid: kartKimlik, html: '', aciklama: '', sifre: null,
        ek: {
          turu: 'UYGULAMAICERIK', _secilenSetId: 'kutuk-stok.hareket', bilesen: 'kutuk-stok-hareket',
          parametreler: [
            { ismi: 'tip', degeri: farkTip },
            { ismi: 'miktar', degeri: farkMiktar },
            { ismi: 'aciklama', degeri: 'Sayım farkı (otomatik)' },
          ],
          tip: farkTip, miktar: farkMiktar, aciklama: 'Sayım farkı (otomatik)',
        },
      };

      const fdKart = new FormData();
      fdKart.append('req_body', JSON.stringify(farkKart));
      this.ekleIstek.parametreler = fdKart;
      await this.ekleIstek.isteSync();

      const fdIc = new FormData();
      fdIc.append('req_body', JSON.stringify(farkIcerik));
      this.ekleIstek.parametreler = fdIc;
      await this.ekleIstek.isteSync();
    } catch (e) {
      console.warn('[KutukStok] Sayım farkı kaydedilemedi:', parentId, e);
    }
  }

  /** ek objesinden parametre değerini okur: önce düz alan (aggregate ile aynı), sonra parametreler[] */
  private _ekDeger(ek: any, ismi: string): any {
    if (ek?.[ismi] != null && ek[ismi] !== '') return ek[ismi];
    return ek?.parametreler?.find((p: any) => p.ismi === ismi)?.degeri ?? '';
  }

  private mentionBildirimGonderInternal(kart: any, icerikler: any[]) {
    if (!kart?._id) return;
    if (!this.lisans('mention')) return;   // mention bildirimi premium
    const htmller = icerikler
      .map((i: any) => i.html || '')
      .filter((h: string) => h.includes('data-user-id'));
    if (htmller.length > 0) {
      this.kartBildirim.mentionBildirimGonder(
        kart._id,
        kart.veri?.kurdela?.baslik || '',
        htmller,
      );
    }
  }
}
